import { Module } from '@nestjs/common';
import { NewsfeedController } from './controllers/newsfeed.controller';
import { NewsfeedService } from './services/newsfeed.service';
import { MikroOrmModule } from '@mikro-orm/nestjs';
import { Newsfeed } from './entities/newsfeed.entity';

@Module({
  imports: [MikroOrmModule.forFeature([Newsfeed])],
  controllers: [NewsfeedController],
  providers: [NewsfeedService],
  exports: [NewsfeedService],
})
export class NewsfeedModule {}
